import React from 'react';
import { Stack, Typography } from '@mui/material';
import { MdError } from "react-icons/md";
import { Link } from 'react-router-dom';


import Modal from "../../components/uiComponent/modal/index";
import AgGrid from "../../components/ag-grid-table/index";
import Badge from '../../components/uiComponent/bages';

import { convertUtcToEst } from "../../utils/helpers.js";

import { MappingAlertWrapper } from './style';

import { capitalize } from 'lodash';

const defaultColDef = {
  resizable: true,
  sortable: false,
  filter: false,
  flex: 1,
};

const MappingAlert = ({ showMappingAlert, setShowMappingAlert, rowData, errorMessage }) => {
  const columnDefs = [
    {
      headerName: 'Order Name',
      cellRenderer: ({ data }) => {
        const { order_name, id, status } = data?.work_orders_v2 || {};

        return (
          <Link
            to={status === 'Confirmed' ? `/confirm-placement/${id}` : `/inventory/work-order/${id}`}
            style={{ fontSize: '12px', fontWeight: '400', color: '#1565D8', width: '100%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}
            target='_blank'
            hrefLang='https//:www.google.com'
          >
            {order_name || '---'}
          </Link>
        );
      }
    },
    {
      headerName: 'Active Date',
      cellRenderer: ({ data }) => {
        const { created_at } = data?.work_orders_v2 || {};

        return (
          <Typography fontSize={12} fontWeight={400} color="#4E5969">{convertUtcToEst(created_at, { month: '2-digit', day: '2-digit', year: 'numeric' })}</Typography>
        );
      }
    },
    {
      headerName: 'Status',
      headerClass: 'parent-header',
      width: 100,
      cellRenderer: ({ data }) => {
        const { status } = data?.work_orders_v2 || {};
        return (
          <Badge text={status} status={capitalize(status) || 'N/A'} />
        )
      }
    },
  ];

  const handleCloseModal = () => {
    setShowMappingAlert(false);
  };

  return (
    <Modal
      removeIcon
      open={showMappingAlert}
      onHide={handleCloseModal}
      onClose={handleCloseModal}
    >
      <MappingAlertWrapper>
        <Typography component="h6" fontSize="18px" fontWeight={700} color="#1565D8" marginTop={2}>Mapping Alert</Typography>
        <Stack direction="row" marginBottom={2} marginTop={1} spacing={0.5}>
        <MdError style={{fontSize: '16px', color: 'red'}} />
        <Typography component="h6" fontSize="12px" fontWeight={700} color="red">{errorMessage || '---'}</Typography>
        </Stack>
        <AgGrid
          user_referrals={rowData}
          defaultColDef={defaultColDef}
          columnDefinitions={columnDefs}
          rowHeight={40}
          headerHeight={32}
          height="565px"
        />
      </MappingAlertWrapper>
    </Modal>
  )
}

export default MappingAlert